export const administrationAccountsSiteLocationInvoiceAddress = {
    template: require('./administration-accounts-site-location-invoice-address.html'),
    controller: 'AdministrationAccountsSiteLocationInvoiceAddressController'
};
